import { Component, OnInit } from '@angular/core';
import {_HttpClient} from '@delon/theme';
import {NzModalRef} from 'ng-zorro-antd';
import {NzModalService} from 'ng-zorro-antd';
import {NzMessageService} from 'ng-zorro-antd';
import {Input} from '@angular/core';
import {SystemContants} from '@core/constants';

@Component({
  selector: 'app-bill-detail-editor',
  templateUrl: './bill-detail-editor.component.html',
  styles: []
})
export class BillDetailEditorComponent implements OnInit {

  @Input()
  record: any;

  details: any[] = [];
  ngOnInit(): void {
    this.loadDetail();
  }

  constructor(private http: _HttpClient, private modal: NzModalRef, private msg: NzMessageService, private modalService: NzModalService) {}

  ok() {
    this.modal.destroy(1);
  }

  cancel() {
    this.modal.destroy();
  }

  deleteDetail(index: number, data: any) {
    this.modalService.confirm({
      nzTitle: '提示',
      nzContent: '确定要删除吗？',
      nzOnOk: () => {
        if (data.id != null) {
          this.http.delete('api/app/bill/detail/id/'+ data.id).subscribe((resp) => {
            if (resp.status === SystemContants.STATUS_SUCCESS) {
              let hs:any = [];
              Object.assign(hs, this.details);
              hs.splice(index,  1);
              this.details = hs;
            }
          })
        } else {
          let hs:any = [];
          Object.assign(hs, this.details);
          hs.splice(index,  1);
          this.details = hs;
        }

      }
    });
  }

  addNew() {
    let arr: any = [];
    let feeDate = null;
    if (this.details.length>0 && this.details[this.details.length-1].feeDate != null) {
      feeDate = this.details[this.details.length-1].feeDate;
    }

    Object.assign(arr, this.details);
    arr.push({billId: this.record.id, feeDate: feeDate});
    this.details = arr;
  }

  calcTotalAmount() {
    let total = 0;
    this.details.forEach((detail) => {
      if (detail.amount) {
        total += parseFloat(detail.amount);

      }
    })
    return total;
  }

  loadDetail() {
    this.http.get<any>('api/app/bill/detail/list/'+this.record.id).subscribe((resp) => {
      if (resp.status == SystemContants.STATUS_SUCCESS) {
        this.details = resp.data;
      }
    });

  }

  saveDetail() {
    this.http.post<any>('api/app/bill/detail', this.details).subscribe((resp) => {
      if (resp.status == SystemContants.STATUS_SUCCESS) {
        this.loadDetail();
        this.msg.success("保存成功");
      }
    })
  }



}
